import React from 'react';
import s from './solution-info.scss';
import { composer } from '../../../../component-decorators/composer';
import { CarouselPreviewWrapper } from '../../preview-elements/carousel-wrapper';
import { Carousel, Box, Proportion } from 'wix-style-react';
import { getClientImageURL } from '../../../../common/getClientImageURL';
import { biLogger } from '../../../../bi';
export var dtoToPreviewProps = function (solutionDto) {
    var images = solutionDto.assetsMap.images || solutionDto.assetsMap.screenshots;
    var videos = solutionDto.assetsMap &&
        solutionDto.assetsMap.galleryVideos &&
        solutionDto.assetsMap.galleryVideos.assets
            .filter(function (v) { return v.mediaType === 'YOUTUBE'; })
            .map(function (v) { return v.url; });
    return {
        previews: images &&
            images.assets
                .filter(function (asset) { return asset.mediaType === 'IMAGE'; })
                .map(function (asset) {
                return {
                    src: asset.url,
                };
            }),
        videos: videos,
        appId: solutionDto.baseInfo.id,
    };
};
var landscape = 4 / 3;
export var SolutionInfoPreview = composer()
    .withExperiments()
    .compose(function (props) {
    return (React.createElement(Box, null,
        React.createElement(CarouselPreviewWrapper, { previews: props.previews },
            React.createElement(Carousel, { buttonSkin: "inverted", dataHook: "preview-carousel", className: s.previewContainer, beforeChange: function () {
                    return biLogger.appMarketAppPageAppGalleryClick({
                        app_id: props.appId,
                        tag_name: 'app_page',
                    });
                } },
                props.videos && props.videos.length > 0 && (React.createElement(Proportion, { aspectRatio: landscape },
                    ' ',
                    React.createElement(Video, { videoUrl: props.videos[0] }),
                    ' ')),
                props.previews &&
                    props.previews.map(function (img) { return (
                    // tslint:disable-next-line:jsx-key
                    React.createElement(Proportion, { "data-hook": "hook-" + img.src, aspectRatio: landscape },
                        React.createElement(Image, { imgUrl: img.src }),
                        ' ')); })))));
});
function Video(_a) {
    var videoUrl = _a.videoUrl;
    return (React.createElement("iframe", { width: "100%", height: "100%", src: videoUrl + "?rel=0", className: s.carouselVideo, allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" }));
}
function Image(_a) {
    var imgUrl = _a.imgUrl;
    var mobileBreakpoint = 600;
    var getCarosualImageSrc = function (width, height) {
        return getClientImageURL(imgUrl, {
            originalWidth: 1000,
            originalHeight: 720,
            toWidth: width,
            toHeight: height,
        });
    };
    var mobileSrc = getCarosualImageSrc(430, 330);
    var desktopSrc = getCarosualImageSrc(605, 465);
    return (React.createElement("picture", { key: imgUrl },
        React.createElement("source", { media: "(max-width: " + mobileBreakpoint + "px)", srcSet: mobileSrc }),
        React.createElement("img", { style: { width: '100%', height: 'auto' }, src: desktopSrc })));
}
//# sourceMappingURL=solution-info-preview.js.map